import { apiConfiguration } from "plumbing/api/ApiConfiguration";
import axios from "axios";

export const getTrainingVideoById = (id: string | number) => {
  const url = `${apiConfiguration.apiUrl}/training-videos/${id}`;
  return axios.get<TrainingVideoModel>(url);
};
